import { render } from "./welcomePage.vue?vue&type=template&id=1e368b7c&scoped=true"
import script from "./welcomePage.vue?vue&type=script&lang=js"
export * from "./welcomePage.vue?vue&type=script&lang=js"

import "./welcomePage.vue?vue&type=style&index=0&id=1e368b7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e368b7c"]])

export default __exports__